// TopicCard.tsx
import { BookOpen, Play } from "lucide-react";
import { QuizTopic } from "./types";

interface TopicCardProps {
  topic: QuizTopic;
  isSelected: boolean;
  onSelect: () => void;
  onStart: () => void;
}

export const TopicCard = ({ topic, isSelected, onSelect, onStart }: TopicCardProps) => (
  <button
    onClick={onSelect}
    className={`group relative overflow-hidden rounded-[2rem] border bg-white text-left transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl ${
      isSelected ? "ring-4 ring-emerald-300" : ""
    }`}
  >
    <div className={`h-40 ${topic.color} relative`}>
      <div className="absolute inset-0 bg-black/10" />
      <div className="absolute top-5 left-5 w-14 h-14 rounded-2xl bg-white/20 backdrop-blur flex items-center justify-center text-white">
        <BookOpen size={26} />
      </div>
    </div>

    <div className="p-7">
      <h2 className="text-2xl font-bold mb-3">{topic.title}</h2>
      <p className="text-gray-600 leading-relaxed mb-6 min-h-[72px]">{topic.description}</p>
      
      <div className="flex flex-wrap gap-3 mb-6">
        <TopicBadge text={`${topic.questions.length} Questions`} />
        <TopicBadge text={`Pass: ${topic.passingPercentage}%`} />
      </div>

      <button
        onClick={(e) => {
          e.stopPropagation();
          onStart();
        }}
        className={`w-full h-14 rounded-2xl text-white font-semibold flex items-center justify-center gap-2 transition group-hover:scale-[1.01] ${topic.color}`}
      >
        <Play size={18} />
        Start Quiz
      </button>
    </div>
  </button>
);

const TopicBadge = ({ text }: { text: string }) => (
  <span className="px-4 py-2 rounded-xl bg-gray-100 text-sm font-medium">{text}</span>
);